import React from 'react';
import { useNavigate } from 'react-router-dom';

const WelcomeHero = () => {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen bg-cover bg-center flex items-center justify-center"
      style={{ backgroundImage: "url('https://source.unsplash.com/1600x900/?innovation,technology')" }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black opacity-60 z-0"></div>

      {/* Content Card */}
      <div className="relative z-10 bg-white/90 backdrop-blur-lg p-10 max-w-4xl rounded-lg shadow-lg animate-fadeIn text-gray-800">
        <h2 className="text-4xl font-bold text-center text-blue-900 mb-6">
          💡 We’re glad you’re here.
        </h2>

        <p className="mb-4 leading-relaxed text-lg">
          As we welcome you to our community, it's important to highlight the mission that fuels our passion and purpose.
          We're here to empower millions of creative minds to transform their thoughts into viable ideas and groundbreaking innovations.
        </p>

        <ul className="list-disc pl-5 text-base mb-6 space-y-2">
          <li><strong>🎯 Creative Challenges:</strong> Push your boundaries and unlock new skills.</li>
          <li><strong>🚀 Innovation Showcases:</strong> Share your ideas and get feedback.</li>
          <li><strong>🤝 Mentorship Opportunities:</strong> Connect with seasoned experts and leaders.</li>
          <li><strong>📚 Learning Resources:</strong> Access curated content for skills growth.</li>
          <li><strong>🌐 Networking Events:</strong> Join events and build your innovation tribe.</li>
        </ul>

        <p className="text-base mb-6">
          Together, we'll embark on a path toward realizing potential and driving change.
          Your presence adds to the diversity of ideas and perspectives in our innovation ecosystem.
        </p>

        <div className="flex justify-center gap-4">
          <button
            onClick={() => navigate('/register')}
            className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded shadow-md transition"
          >
            🚀 Join Now
          </button>
          <button
            onClick={() => navigate('/login')}
            className="border border-blue-700 hover:bg-blue-50 text-blue-700 px-6 py-2 rounded transition"
          >
            🔐 Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHero;
